export const BRAND_NAME = 'HeroBet247Net';
// Note: It is the main site url. Ex - HeroBet247Net.com, etc.
export const BRAND_DOMAIN = 'herobet247.net';
// Note: It is the main site url. Ex - playnetgaming.net, etc.
export const BRAND_DOMAIN_SKIN_URL = 'herobet247.net';
export const PROVIDER = 'BetFair';
export const PROVIDER_ID = 'BetFair';
export const BACKEND_DOMAIN = 'cue88.com';